<template>
	<StandardCard>
		<header v-if="$flowstore.checkout.meta.product.image" class="h-36 overflow-hidden rounded-t">
			<ImageElement
				:src="$flowstore.checkout.meta.product.image"
				:priority="isDesktop"
				class="h-full w-full object-cover object-center"
			/>
		</header>

		<div class="py-6 px-8">
			<h1>
				{{ $flowstore.checkout.meta.product.name }}
			</h1>

			<HtmlContent :html="$flowstore.checkout.meta.product.description" class="text-qwr-haze-600 pb-4" />

			<template v-if="$flowstore.checkout.meta.usps && $flowstore.checkout.meta.usps.length > 0">
				<p v-if="!$flowstore.checkout.meta.product.description" class="text-gray-500 pb-4 text-sm">
					{{ t('your_experience') }}
				</p>
				<UspList :usps="$flowstore.checkout.meta.usps" />
			</template>
		</div>

		<ArrivalInfo />
		<PersonChoices />
		<AdditionalCosts />
		<VoucherInfo />
		<UpsellList />

		<footer class="py-6 px-8 flex flex-row justify-between border-t border-gray-200">
			<div>{{ t('total') }}</div>
			<div class="text-right">
				<PriceText
					v-if="$flowstore.checkout.meta.total_price_without_discount !== $flowstore.checkout.meta.total_price"
					:value="$flowstore.checkout.meta.total_price_without_discount"
					class="font-semibold text-xl text-qwr-haze-300 mr-3 line-through"
				/>
				<PriceText :value="$flowstore.checkout.meta.total_price" class="font-semibold text-xl" />
				<div v-if="$flowstore.checkout.meta.total_price_discount_reason" class="text-qwr-haze-600">
					{{ $flowstore.checkout.meta.total_price_discount_reason }}
				</div>
			</div>
		</footer>
	</StandardCard>
</template>

<script lang="ts" setup>
import { useMediaQuery } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import AdditionalCosts from '@/components/receipt/AdditionalCosts.vue';
import ArrivalInfo from '@/components/receipt/ArrivalInfo.vue';
import StandardCard from '@/components/StandardCard.vue';
import HtmlContent from '@/components/HtmlContent.vue';
import ImageElement from '@/components/ImageElement.vue';
import PersonChoices from '@/components/receipt/PersonChoices.vue';
import PriceText from '@/components/PriceText.vue';
import UpsellList from '@/components/receipt/UpsellList.vue';
import UspList from '@/components/UspList.vue';
import VoucherInfo from '@/components/receipt/VoucherInfo.vue';

const { t } = useI18n();

const isDesktop = useMediaQuery('(min-width: 1024px)');
</script>
